// for user profile information
export const NO_INFORMATION = "no information";

// for find users information
export const FOLLOW_TEXT = "Follow";
export const UNFOLLOW_TEXT = "Unfollow";
export const YOU_FOLLOW = "You follow";
export const YOU_UNFOLLOW = "You unfollow";